import { all, call, fork, put, select, takeEvery } from "redux-saga/effects";
import {
  actions
  //getters
} from "./model";
import { apiCall } from "App/Data/sagas";
import { registerError } from "redux/modules/errors/actions";
import { showSnackbar } from "redux/modules/snackbar/actions";
import { hideModal } from "redux/modules/modal/actions";
import {
  actions as FormActions,
  getters as FormGetters
} from "ui-kit/Form/model";
import * as R from "ramda";
import { FORM_ID } from "./constants";
import { eventDetails as getPortalEventDetails } from "redux/modules/portal/selectors";

const save = function*({ payload: { onDone } }) {
  yield put(actions.setProcessing(true));
  const eventDetails = yield select(getPortalEventDetails);
  const fields = yield select(FormGetters.fields, {
    instanceId: FORM_ID
  });
  // const existingUserData = yield select(getters.existingUserData);
  // const isEditing = !R.isEmpty(existingUserData);
  // if (!isEditing) {
  //   data.contactId = R.last(location.pathname.split("/"));
  // }

  let newMember;
  try {
    yield call(apiCall, {
      method: "post",
      url: `/portal/event/${eventDetails.uuid}/profile/contact-members`,
      data: {
        firstName: R.pathOr(null, ["firstName", "value"], fields),
        lastName: R.pathOr(null, ["lastName", "value"], fields),
        email: R.pathOr(null, ["email", "value"], fields),
        role: R.pathOr(null, ["role", "value"], fields)
      }
    });

    // if (!isEditing) {
    //   newMember = { ...data, id: response.payload.id };
    // }
    yield all([
      put(
        showSnackbar({
          message: "Additional Contact Added"
        })
      ),
      put(
        FormActions.clearValues(null, {
          meta: {
            instanceId: FORM_ID
          }
        })
      ),
      put(
        onDone(
          newMember
            ? {
                orgId: eventDetails.org_id,
                newMember
              }
            : { orgId: eventDetails.org_id }
        )
      ),
      put(hideModal())
    ]);
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: `An error occurred saving contact member`
        }
      ])
    );
  } finally {
    yield put(actions.setProcessing(false));
  }
};

const watchSave = function*() {
  yield takeEvery(actions.save.type, save);
};

const rootSaga = function*() {
  yield all([fork(watchSave)]);
};
export default rootSaga;
